// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agents/models" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentsModels } from "./constants";
import type { GenerativeAiAgentsModelsResult } from "./types";
import { isGenerativeAiAgentsModelsResult } from "./validators";

export interface GetGenerativeAiAgentsModelsParams {
  interaction_site?: number;
}

export const getGenerativeAiAgentsModels = reactQueryFetcherAdapter(
  generativeAiAgentsModels,
  (signal: AbortSignal, params?: GetGenerativeAiAgentsModelsParams): Promise<GenerativeAiAgentsModelsResult> => {
    const queryParams: Record<string, string> = {};
    if (params?.interaction_site !== undefined) {
      queryParams.interaction_site = String(params.interaction_site);
    }
    return fetch("/generative_ai/agents/models", "GET", queryParams, { signal });
  },
  isGenerativeAiAgentsModelsResult
);
